<template>
  <div class="main">
    <div class="pic">
      <img class="img" src="../../images/shouye.png" alt="" />
    </div>
    <div class="userinfo">
      <div class="users">
        <div class="mesg">管理员登录</div>

        <el-form ref="form" :model="form" label-width="80px">
          <el-form-item>
            <el-input v-model="form.username" placeholder="用户名"></el-input>
          </el-form-item>
          <el-form-item>
            <el-input
              v-model="form.password"
              type="password"
              placeholder="密码"
            ></el-input>
          </el-form-item>
          <el-form-item>
            <el-button class="btn" type="primary" @click="login"
              >立即登录</el-button
            >
          </el-form-item>
        </el-form>
      </div>
    </div>
  </div>
</template>

<script>
import { selectUser } from "@/http/commodity.js";

import { login } from "@/http/api.js";
export default {
  data() {
    return {
      form: {
        username: "",
        password: "",
      },
    };
  },
  methods: {
    // 查看用户权限
    async handlerSelectUser() {
      let res = await selectUser();
      localStorage.setItem("isMain", res.data.isMain);
      res.data.isMain == 1
        ? this.$router.push({ path: "/shop" })
        : this.$router.push({ path: "/commodity" });
    },
    async login() {
      let query = {
        username: this.form.username,
        password: this.form.password,
      };
      let res = await login(query);
      // 将token放到本地
      localStorage.setItem("token", res.token);
      console.log(localStorage.getItem("token"));

      if (res.code == 1) {
        this.handlerSelectUser();
      }
      if (res.code === 500) {
        this.$message({
          showClose: true,
          message: res.msg,
          type: "error",
        });
      }
    },
  },
};
</script>

<style lang="scss">
@import "@/style/views/login/login.scss";
</style>